import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { switchMap, take } from 'rxjs/operators';
import { isPaymentCollectionsReconciliationRequest } from '@core/reconciliation-api-url';
import { environment } from '../../../environments/environment';
import { TenantService } from '../services/tenant.service';

function isProtectedApiRequest(url: string): boolean {
  return url.startsWith(environment.apiUrl)
    || url.startsWith(environment.goskalerApiUrl)
    || isPaymentCollectionsReconciliationRequest(url);
}

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (!isProtectedApiRequest(req.url)) {
    return next(req);
  }

  const auth = inject(AuthService);
  return auth.getAccessTokenSilently().pipe(
    take(1),
    switchMap(token => {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next(authReq);
    })
  );
}
